import {
    FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField
} from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme
} from "@material-ui/core/styles";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from '@mui/material/Button';
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
    createProject, getApplications, getClient, getDealer, getInstitute, getProjectsFiletr,
    getSampleAccessioning, updateProject,getProjects
} from "../../actions/GenomicsResearchAction";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        content: {
            width: "80%",
            flexGrow: 21,
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        paper: {
            marginTop: "2rem",
            padding: "0.5rem 2rem 2rem 2rem",
            width: "100%",
        },
        hoveItem: {
            cursor: "pointer",
        },
        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
    })
);
interface Props {
    getClient: any;
    client: any;
    getInstitute: any;
    institute: any;
    getApplications: any;
    applications: any;
    projectsFilter: any;
    getProjectsFiletr: any;
    getSampleAccessioning: any;
    samplesAccessioning: any;
    createProject: any;
    updateProject: any;
    getDealer: any;
    dealer: any;
    getProjects:any;
    projects:any;

}
const StopsPlace: React.FC<Props> = ({
    getClient,
    client,
    getInstitute,
    institute,
    getApplications,
    applications,
    getProjectsFiletr,
    projectsFilter,
    getSampleAccessioning,
    samplesAccessioning,
    createProject,
    updateProject,
    getDealer,
    dealer,
    getProjects,
    projects,

}) => {
    const history = useHistory();
    const timer = useRef<any>(0);
    const [libraries, setLibraries] = useState<any>("");
    const [analysis, setAnalysis] = useState<any>("");
    const [delName, setDelName] = useState<any>("");
    const [numOfPassSamples, setNumOfPassSamples] = useState<any>("");
    const [bdPoint, setBdPoint] = useState<any>("");
    const [editId, setEditId] = useState<any>("");
    const [analysisPostion, setAnalysisPostion] = useState<any>("");
    const [clientName, setClientgName] = useState<any>("");
    const { id } = useParams<{ id: string }>();
    const [requirement, setRequiredment] = useState<any>([]);
    const [clients, setClients] = React.useState<any>("");
    const [dealerName, setDealerName] = useState<any>("");
    const [insName, setInsName] = useState<any>("");
    const [instituteName, setInstituteName] = useState<any>("");
    const [isEdit, setIsEdit] = useState<any>(false);
    const [projectId, setProjectId] = useState<any>("");
    const [projectCreated, setProjectCreated] = useState<any>("");
    const [comment, setComment] = useState<any>("");
    const [invoiceStatus, setInvoiceStatus] = useState<any>("");
    const [invoiceDate, setInvoiceDate] = useState<any>();
    const [projectValue, setProjectValue] = useState<any>("");
    const [amountRecived, setAmountrecived] = useState<any>("");
    const [paymentStatus, setPaymentStatus] = useState<any>("");
    const [displayProject, setDisplayProject] = useState<string>("");
    const [project, setProject] = useState<any>(null);
    console.log(project,"project")
    const [inputList, setInputList] = useState<any>([
        {
            platform: "",
            application: "",
            title: "",
            sampleCount: "",
            dataSizeRequirement: "",

        },
    ]);

    const handleInputChange = (index: any, val: any, key: any) => {
        let list = [...inputList];
        if (key === "platform" && val !== undefined) {
            list[index]["platform"] = val;
        } else if (key === "application") {
            list[index]["application"] = val._id;
        } else if (key === "title") {
            list[index]["title"] = val;
        } else if (key === "sampleCount") {
            list[index]["sampleCount"] = val;
        } else if (key === "dataSizeRequirement") {
            list[index]["dataSizeRequirement"] = val;
        }
        setInputList(list);
    };
    const handleRemoveClick = (index: any) => {
        const list = [...inputList];
        list.splice(index, 1);
        setInputList(list);
    };
    const handleAddClick = () => {
        setInputList([
            ...inputList,
            {
                platform: "",
                application: "",
                title: "",
                sampleCount: "",
                dataSizeRequirement: "",


            },
        ]);
    };
    const handleProjectsdata = async (e: any) => {
        e.preventDefault();
        const projectDataDataEdit = {
            librariesCount: libraries,
            dataSizeRequirement: requirement,
            bdPoint: bdPoint,
            analysisRequirement: analysis,
            subProjects: inputList,
            sampleId: id,
            analysisPosition: analysisPostion,
            id: projectId,
            projectDate: projectCreated,
            comment: comment,
            paymentStatus: paymentStatus,
            receivedAmount: amountRecived,
            invoiceAmount: projectValue,
            invoiceDate: invoiceDate,
            invoiceStatus: invoiceStatus,
            parentProject:project?._id,
        };
        if (analysisPostion === "") {
            delete projectDataDataEdit.analysisPosition;
        }
        if (invoiceDate === "") {
            delete projectDataDataEdit.invoiceDate;
        }

        await updateProject(projectDataDataEdit, editId);
        history.push(`/dashboard/gnre/projects/data`);
    };
    useEffect(() => {
        setInputList([]);
        getClient();
        getInstitute();
        getApplications();
        getProjects();
        getProjectsFiletr(id);
        getSampleAccessioning();
        getDealer();
    }, []);

    useEffect(() => {
        let storeData: any = [];
        if (projectsFilter) {
            const list = projectsFilter;
            setIsEdit(true);
            setEditId(list._id);
            setLibraries(list?.librariesCount);
            setRequiredment(list?.dataSizeRequirement);
            setBdPoint(list?.bdPoint || "");
            setClientgName(list?.scientist?.name || "");
            setInsName(list?.institute?.name || "");
            setDealerName(list?.dealer?.firmName || "");
            setNumOfPassSamples(list?.sample?.passedCount || "");
            setAnalysis(list?.analysisRequirement);
            setAnalysisPostion(list?.analysisPosition);
            setProjectId(list?.id);
            setComment(list?.comment);
            setProjectCreated(list?.projectDate ? list?.projectDate.split("T")[0] : '');
            setInvoiceDate(list?.invoiceDate ? list?.invoiceDate.split("T")[0] : '');
            setInvoiceStatus(list?.invoiceStatus);
            setAmountrecived(list?.receivedAmount);
            setPaymentStatus(list?.paymentStatus);
            setProjectValue(list?.invoiceAmount);
            setProject(list?.parentProject?._id)
            setDisplayProject(list?.parentProject?.projectId)
            list?.subProjects?.map((subp: any) => {
                storeData.push({
                    "platform": subp?.platform,
                    "application": subp?.application?._id,
                    "sampleCount": subp?.sampleCount,
                    "title": subp?.title,
                    "name": subp?.application?.name,
                    "dataSizeRequirement": subp?.dataSizeRequirement,
                })
            })
        }
        setInputList(storeData);
    }, [projectsFilter]);
    return (
        <Grid container spacing={2}>
            <form onSubmit={handleProjectsdata} style={{ width: "100%" }}>
                <Paper style={{ margin: "70px auto", width: "90%", background: "#eff", marginTop: 40 }}>
                    <h2 style={{ fontWeight: "bold", paddingTop: "20px", paddingBottom: "10px", textAlign: "center" }}>Edit Projects Details</h2>
                    <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="flex-end"
                        spacing={2}
                        style={{ margin: "1rem auto" }}
                    >
                        <Grid container spacing={2} style={{ marginLeft: 1 }}>
                            <Grid item xs={12} sm={4} md={3}>
                                <Autocomplete
                                    id="client_name"
                                    disablePortal
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                                            setClients(obj._id);
                                        }
                                    }}
                                    defaultValue={
                                        { id: "", name: clientName }
                                    }
                                    options={client?.results || []}
                                    inputValue={clientName}
                                    blurOnSelect
                                    disabled
                                    getOptionLabel={(option: any) => `${option?.name}`}
                                    onInputChange={(event, newInputValue) => {
                                        setClientgName(newInputValue);
                                        clearTimeout(timer.current);
                                        timer.current = setTimeout(() => {
                                            getClient(newInputValue);
                                        }, 1000);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            className="input"
                                            label="Client"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <Autocomplete
                                    id="Institute"
                                    disablePortal
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                                            setInstituteName(obj._id);
                                        }
                                    }}
                                    defaultValue={
                                        { id: "", name: insName }
                                    }
                                    inputValue={insName || []}
                                    options={institute?.results || ""}
                                    blurOnSelect
                                    disabled
                                    disableCloseOnSelect
                                    getOptionLabel={(option: any) => `${option?.name}`}
                                    onInputChange={(event, newInputValue) => {
                                        clearTimeout(timer.current);
                                        timer.current = setTimeout(() => {
                                            getInstitute(newInputValue);
                                        }, 1000);
                                        setInsName(newInputValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            className="input"
                                            label="Institute Name"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <Autocomplete
                                    id="Dealer"
                                    disablePortal
                                    key={dealer}
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                                            setDealerName(obj._id);
                                        }
                                    }}
                                    defaultValue={
                                        { id: "", name: delName }
                                    }
                                    inputValue={dealerName || ""}
                                    options={dealer?.results || []}
                                    blurOnSelect
                                    disabled
                                    getOptionLabel={(option: any) => `${option?.name}`}
                                    onInputChange={(event, newInputValue) => {
                                        clearTimeout(timer.current);
                                        timer.current = setTimeout(() => {
                                            getDealer(newInputValue);
                                        }, 1000);
                                        setDelName(newInputValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            className="input"
                                            label="Dealer Name"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    className="input"
                                    name="title"
                                    type="number"
                                    label="Number Of Pass Samples"
                                    value={numOfPassSamples || ""}
                                    onChange={(e) => setNumOfPassSamples(e.target.value)}
                                    disabled
                                    variant="outlined"
                                    style={{ margin: "0", width: "100%" }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <Autocomplete
                                    id="Project_id"
                                    onChange={(event, newValue) => {
                                        setProject(newValue);
                                    }}
                                    defaultValue={projects?.projectId}
                                    options={projects?.results || []}
                                    inputValue={displayProject}
                                    blurOnSelect
                                    disabled
                                    getOptionLabel={(option: any) => {
                                        return (
                                            (option?.projectId) + " " +
                                            (option?.scientist?.name || "")
                                        );
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                        let data = newInputValue.split(" ");
                                        clearTimeout(timer.current);
                                        timer.current = setTimeout(() => {
                                            if (data.length > 0) {
                                                getProjects(`?parentOnly=true&scientist=${clients}`);
                                            }
                                        }, 1000);
                                        setDisplayProject(newInputValue)
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            className="input"
                                            label="Parent Project"
                                            placeholder="Search ID/scientist Name"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    className="input"
                                    name="title"
                                    type="number"
                                    fullWidth
                                    label="Project ID"
                                    placeholder="Enter Project ID"
                                    value={projectId + ""}
                                    onChange={(e) => setProjectId(Number(e.target.value))}
                                    variant="outlined"
                                    required
                                    disabled
                                    style={{ margin: "0", width: "100%" }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    label="Project Created Date"
                                    variant="outlined"
                                    className="input"
                                    type="date"
                                    fullWidth
                                    value={projectCreated}
                                    onChange={(e: any) => setProjectCreated(e.target.value)}
                                    disabled
                                    inputProps={{
                                        max: moment().format("YYYY-MM-DD"),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    className="input"
                                    name="Number Of Libaraies"
                                    label="Number Of Libaraies"
                                    type="number"
                                    onInput={(e: any) => {
                                        e.target.value = Math.max(0, parseInt(e.target.value))
                                            .toString()
                                            .slice(0, 10);
                                    }}
                                    onWheel={(e: any) => e.target.blur()}
                                    value={libraries || ""}
                                    placeholder="Enter Number Of libraries"
                                    variant="outlined"
                                    required
                                    style={{ margin: "0", width: "100%" }}
                                    onChange={(e) =>
                                        setLibraries(Number(e.target.value))
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <FormControl style={{ width: "100%" }} className="input">
                                    <InputLabel>BD Point Of Contact</InputLabel>
                                    <Select
                                        label="BD Point Of Contact"
                                        variant="outlined"
                                        className="input"
                                        fullWidth
                                        value={bdPoint}
                                        style={{ width: "100%", height: "40px" }}
                                        onChange={(e) => setBdPoint(e.target.value)}
                                    >
                                        <MenuItem value="none" disabled> Select BD Point </MenuItem>
                                        <MenuItem value="ZM North ">ZM North </MenuItem>
                                        <MenuItem value="ZM South">ZM South</MenuItem>
                                        <MenuItem value="ZM West">ZM West</MenuItem>
                                        <MenuItem value="ZM East">ZM East</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <FormControl style={{ width: "100%" }} className="input">
                                    <InputLabel>Analysis Requirement</InputLabel>
                                    <Select
                                        label="Analysis Requirement"
                                        variant="outlined"
                                        className="input"
                                        fullWidth
                                        value={analysis}
                                        disabled
                                        style={{ width: "100%", height: "40px" }}
                                        onChange={(e) => setAnalysis(e.target.value)}
                                    >
                                        <MenuItem value="none" disabled>Analysis Requirement</MenuItem>
                                        <MenuItem value="true">Yes</MenuItem>
                                        <MenuItem value="false">No</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {analysis === false ? "" :
                                <Grid item xs={12} sm={4} md={3}>
                                    <FormControl style={{ width: "100%" }} className="input">
                                        <InputLabel>Analysis Type</InputLabel>
                                        <Select
                                            label=""
                                            variant="outlined"
                                            className="input"
                                            fullWidth
                                            value={analysisPostion}
                                            disabled
                                            style={{ width: "100%", height: "40px" }}
                                            onChange={(e) => setAnalysisPostion(e.target.value)}
                                        >
                                            <MenuItem value="none" disabled>Analysis Type</MenuItem>
                                            <MenuItem value="Standard">Standard</MenuItem>
                                            <MenuItem value="Advanced">Advanced</MenuItem>
                                            <MenuItem value="Customized">Customized</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            }
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    id="filled-number"
                                    className="input"
                                    label="Comment"
                                    fullWidth
                                    value={comment}
                                    placeholder="type Comments"
                                    variant="outlined"
                                    onChange={(e) => setComment(e.target.value)}

                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <FormControl style={{ width: "100%" }} className="input">
                                    <InputLabel>Invoice Status</InputLabel>
                                    <Select
                                        label="Inoice Status"
                                        variant="outlined"
                                        className="input"
                                        fullWidth
                                        value={invoiceStatus || "none"}
                                        style={{ width: "100%", height: "40px" }}
                                        onChange={(e) => setInvoiceStatus(e.target.value)}
                                    >
                                        <MenuItem value="none" disabled><em>Invoice Status</em></MenuItem>
                                        <MenuItem value="Done">Done</MenuItem>
                                        <MenuItem value="Not Done">Not Done</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <FormControl style={{ width: "100%" }} className="input">
                                    <InputLabel>Payment Status</InputLabel>
                                    <Select
                                        label="Invoice Status"
                                        variant="outlined"
                                        className="input"
                                        fullWidth
                                        value={paymentStatus || "none"}
                                        style={{ width: "100%", height: "40px" }}
                                        onChange={(e) => setPaymentStatus(e.target.value)}
                                    >
                                        <MenuItem value="none" disabled><em>Payment Status</em></MenuItem>
                                        <MenuItem value="Received">Received</MenuItem>
                                        <MenuItem value="Not Received">Not Received</MenuItem>
                                        <MenuItem value="Partial">Partial</MenuItem>
                                        <MenuItem value="Pending">Pending</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    id="filled-number"
                                    className="input"
                                    label="Project Value"
                                    fullWidth
                                    value={projectValue}
                                    placeholder="type Project Value"
                                    variant="outlined"
                                    onChange={(e) => setProjectValue(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    id="filled-number"
                                    className="input"
                                    label="Invoice Date"
                                    fullWidth
                                    type="date"
                                    value={invoiceDate}
                                    placeholder="type Invoice Date"
                                    variant="outlined"
                                    onChange={(e) => setInvoiceDate(e.target.value)}
                                    inputProps={{
                                        max: moment().format("YYYY-MM-DD"),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    id="filled-number"
                                    className="input"
                                    label="Amount Recieved"
                                    fullWidth
                                    value={amountRecived}
                                    placeholder="type Amount Received"
                                    variant="outlined"
                                    onChange={(e) => setAmountrecived(e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    {inputList.map((x: any, index: number) => {
                        return (
                            <Grid
                                container
                                spacing={3}
                                style={{ margin: "1rem auto", background: "#E0F2F1" }}
                            >
                                <Grid item xs={12} sm={4} md={2}>
                                    <FormControl style={{ width: "100%" }} className="input">
                                        <InputLabel>Platform</InputLabel>
                                        <Select
                                            key={isEdit}
                                            label="PlatForm"
                                            variant="outlined"
                                            className="input"
                                            fullWidth
                                            style={{ width: "100%", height: "40px" }}
                                            value={x?.platform}
                                            onChange={(e) =>
                                                handleInputChange(index, e.target.value, "platform")
                                            }
                                        >
                                            <MenuItem value="none" disabled>Select Platform </MenuItem>
                                            <MenuItem value="novaseq">Novaseq </MenuItem>
                                            <MenuItem value="nextseq">Nextseq</MenuItem>
                                            <MenuItem value="Miseq">Miseq</MenuItem>
                                            <MenuItem value="dnbseq">DNBSeq</MenuItem>
                                            <MenuItem value="pacbio">Pacbio</MenuItem>
                                            <MenuItem value="ont">ONT</MenuItem>
                                            <MenuItem value="nanostring">Nanostring</MenuItem>
                                            <MenuItem value="saphyr">Saphyr</MenuItem>
                                            <MenuItem value="iscan">iScan</MenuItem>
                                            <MenuItem value="kaspar">KASPAR</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <Autocomplete
                                        key={isEdit}
                                        id="time"
                                        onChange={(event, newValue) => {
                                            if (newValue) {
                                                let obj = JSON.parse(
                                                    JSON.stringify(newValue, null, " ")
                                                );
                                                handleInputChange(index, obj, "application");
                                            }
                                        }}
                                        options={applications.results || []}
                                        onInputChange={(event, newInputValue) => {
                                            clearTimeout(timer.current);
                                            timer.current = setTimeout(() => {
                                                getApplications(`search=${newInputValue}`);
                                            }, 1000);
                                            handleInputChange(index, newInputValue, "name");
                                        }}
                                        blurOnSelect
                                        aria-required
                                        inputValue={x?.name}
                                        getOptionLabel={(option: any) => `${option?.name}`}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                className="input"
                                                size="small"
                                                variant="outlined"
                                                label="Applications"
                                                required
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={2}>
                                    <TextField
                                        key={isEdit}
                                        label="Sub Project Title"
                                        variant="outlined"
                                        className="input"
                                        fullWidth
                                        value={x?.title}
                                        required
                                        onChange={(e) =>
                                            handleInputChange(index, e.target.value, "title")
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={2}>
                                    <TextField
                                        key={isEdit}
                                        label="No Of Samples"
                                        variant="outlined"
                                        className="input"
                                        fullWidth
                                        value={x?.sampleCount}
                                        required
                                        onChange={(e) =>
                                            handleInputChange(index, Number(e.target.value), "sampleCount")
                                        } />
                                </Grid>
                                <Grid item xs={12} sm={4} md={2}>
                                    <TextField
                                        label="Data Req(GB)"
                                        variant="outlined"
                                        className="input"
                                        placeholder="Enter Data Requirements"
                                        type="number"
                                        required
                                        fullWidth
                                        value={x?.dataSizeRequirement}
                                        onChange={(e) =>
                                            handleInputChange(index, Number(e.target.value), "dataSizeRequirement")
                                        }
                                    />
                                </Grid>
                                <Grid item md={1}>
                                    {inputList.length !== 1 && (
                                        <HighlightOffIcon
                                            style={{
                                                marginBottom: "1rem",
                                                height: "40px",
                                                width: "40px",
                                                borderRadius: "50%",
                                            }}
                                            onClick={() => handleRemoveClick(index)}
                                        />
                                    )}
                                    {inputList.length - 1 === index && inputList.length < 7 && (
                                        <AddCircleIcon
                                            style={{
                                                marginBottom: "1rem",
                                                height: "40px",
                                                width: "40px",
                                                borderRadius: "50%",
                                            }}
                                            onClick={handleAddClick}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        );
                    })}
                    <Grid xs={12} style={{ textAlign: "center", padding: "20px" }}>
                        <Button
                            color="primary"
                            variant="contained"
                            type="submit"
                            style={{ width: 300 }}

                        >
                            Update
                        </Button>
                    </Grid>
                    {/* <Grid item xs={6} style={{ textAlign: "center", padding: "20px" }}>
                        <Button
                            color="secondary"
                            variant="contained"
                            style={{ width:100 }}
                        >
                            reset
                        </Button>
                    </Grid> */}
                </Paper>
            </form>
        </Grid>
    );
};
const mapStateToProps = (state: any) => ({
    client: state.GenomicsCAReducer.client,
    institute: state.GenomicsCAReducer.institute,
    applications: state.GenomicsCAReducer.applications,
    projectsFilter: state.GenomicsCAReducer.projectsFilter,
    samplesAccessioning: state.GenomicsCAReducer.samplesAccessioning,
    dealer: state.GenomicsCAReducer.dealer,
    projects: state.GenomicsCAReducer.projects,

});
export default connect(mapStateToProps, {
    getClient,
    getInstitute,
    getApplications,
    getProjectsFiletr,
    getSampleAccessioning,
    createProject,
    updateProject,
    getDealer,
    getProjects,
})(StopsPlace);
